<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.getSettingConst();
  },
  methods: {
    //設定定数をDBから取得する
    getSettingConst() {
      this.getRequest("/const/getConst", null, null).then((data) => {
        this.$setUseMailDelivery(data.useMailDelivery);
        this.$setUseBulletinBoard(data.useBulletinBoard);
        this.$setUseCognito(data.useCognito);
        this.$setUploadFileSize(data.uploadFileSize_b);
        this.$setUseRoomAddition(data.useRoomAddition);
        this.$setCardType(data.cardType);
        this.$setMealCollectiveEndMonth(data.mealCollectiveEndMonth);
        this.$setVisitorCardIssua(data.visitorCardIssua);
        this.$setUseCalcMagnification(data.useCalcMagnification);
        this.$setUseUpdateEnergyInput(data.useUpdateEnergyInput);
        this.$setUseWithoutEat(data.useWithoutEat);
        this.$setDmsUseFlg(data.dmsUseFlg);
        this.$setCarUseFlg(data.carUseFlg);
        this.$setMealUseFlg(data.mealUseFlg);
        this.$setGasUseFlg(data.gasUseFlg);
        this.$setElUseFlg(data.elUseFlg);
        this.$setWaUseFlg(data.waUseFlg);
        this.$setOcUseFlg(data.ocUseFlg);
        this.$setNeiUseFlg(data.neiUseFlg);
      });
    },
  },
};
</script>
